<template>
    <span>
        <button :id="targetId" type="button" class="review-drafts-help" aria-label="Зачем включать черновики"
            :aria-expanded="open ? 'true' : 'false'" @keydown.esc="open = false">?</button>
        <b-popover :target="targetId" :show.sync="open" triggers="hover focus" placement="bottom"
            container="body" boundary="viewport" custom-class="review-drafts-popover">
            <p>Включите черновики, чтобы увидеть в своде табели, которые ещё не поданы вам на проверку, но уже заполняются.</p>
            <button type="button" class="btn btn-sm btn-outline-secondary" @click="open = false">Понятно</button>
        </b-popover>
    </span>
</template>
<script>
let sequence = 0;
export default {
    name: 'TimesheetReviewDraftsHelp',
    props: {visitCounted: Boolean},
    data() { return {targetId: `review-drafts-help-${++sequence}`, open: false}; },
    mounted() {
        if (this.visitCounted) return;
        this.$emit('visit');
        try {
            const introduce = this.rememberVisit(window.localStorage);
            // BootstrapVue initializes the popover target on its first nextTick.
            this.$nextTick(() => { if (!this._isDestroyed) this.open = introduce; });
        } catch (_) { /* Help remains available without storage. */ }
    },
    methods: {
        rememberVisit(storage) {
            const user = this.$store.getters.currentUser || {};
            const id = user.userId || user.user_id || user.id;
            if (!id) return false;
            const key = `argus:review-drafts-help:v1:${user.company || ''}:${id}`;
            const stored = Number(storage.getItem(key));
            const count = Number.isInteger(stored) && stored >= 0 ? stored : 0;
            if (count >= 5) return false;
            storage.setItem(key, String(count + 1));
            return true;
        }
    }
};
</script>
